import _OnlineHomeworkContent from './model';
import * as _actions from './actions';
import _reducer from './reducer';

export const OnlineHomeworkContent = _OnlineHomeworkContent;
export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/OnlineHomework/Content/index.js